<template>
  <v-card elevation="0" class="pa-4" width="100%">
    <div class="d-flex align-center bar ml-3">
      <v-btn @click="close" icon class="secondary-button bar ma-1" depressed>
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-btn @click="print" icon class="secondary-button bar ma-1" depressed>
        <v-icon>mdi-printer</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <strong class="mr-2 bar hidden-sm-and-down">Itens por linha:</strong>
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            class="secondary-button bar hidden-sm-and-down"
            depressed
            icon
          >
            {{ qtd }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(size, i) in sizes" :key="i" @click="qtd = size">
            <v-list-item-title>{{ size }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div class="d-flex justify-center align-center" v-if="departmentLoading">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <v-row v-else class="ma-0" justify="center">
      <v-col
        v-for="department in departments"
        :key="department.id"
        cols="11"
        :sm="cols"
        :md="cols"
      >
        <v-card
          outlined
          class="pa-4 text-center d-flex flex-column align-center"
          height="100%"
          :width="cols >= 3 ? '100%' : '180px'"
          style="break-inside: avoid"
        >
          <img
            class="mt-4 mb-2"
            :src="
              logo
                ? logo
                : institution && institution.logoPath
                ? institution.logoPath
                : require('../../../../assets/01_-_Reduzido_Cor.png')
            "
            alt="equipacare"
            style="width: 5rem; border-radius: 8px"
          />

          <v-spacer></v-spacer>

          <div class="my-1">
            <strong>Setor:</strong>
            <span> {{ department.departmentName }} </span>
          </div>

          <div class="my-1 mb-4" v-if="department.subDepartmentName">
            <strong>Sub-setor:</strong>
            <span> {{ department.subDepartmentName }} </span>
          </div>

          <v-spacer></v-spacer>

          <Qrcode
            :value="`${baseUrl}?departmentId=${department.departmentId}&subDepartmentId=${department.subDepartmentId}&unidadeId=${department.unidadeId}`"
            :size="cols * 35"
          ></Qrcode>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from '../../../../services/ApiService'
import Qrcode from 'qrcode.vue'

export default {
  name: 'SectorQRCodes',

  components: {
    Qrcode,
  },

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.filter = JSON.parse(sessionStorage.getItem('departmentFilters'))

    this.filter.institutionId = this.institution.id

    this.apiService
      .get(`institution/${this.institution.id}`)
      .then((response) => {
        this.institution = response.content

        this.layout = this.institution.qrCodeSectorCustomization
          ? JSON.parse(this.institution.qrCodeSectorCustomization)
          : this.layout

        this.logo = this.layout.logo
      })

    this.searchDepartment()
  },

  data() {
    return {
      baseUrl: `${window.location.origin}/newCalled`,
      layout: {},
      departments: [],
      departmentLoading: false,
      apiService: new ApiService(),
      cols: 2,
      sizes: [2, 3, 4, 6],
      qtd: 6,
    }
  },

  watch: {
    qtd() {
      switch (this.qtd) {
        case 2:
          this.cols = 6
          break

        case 3:
          this.cols = 4
          break

        case 4:
          this.cols = 3
          break

        case 6:
          this.cols = 2
          break

        default:
          break
      }
    },
  },

  methods: {
    print() {
      window.print()
    },

    close() {
      this.$router.go(-1)
    },

    async searchDepartment() {
      this.departmentLoading = true

      this.apiService
        .post('department/get-qrcodes', this.filter)
        .then((response) => {
          this.departments = response.content
          this.departmentLoading = false
        })
        .catch((err) => {
          this.departmentLoading = false
        })
    },
  },
}
</script>

<style scoped>
@media print {
  .bar {
    display: none;
    height: 0;
    width: 0;
  }
}

.tag {
  display: flex;
  border: 1px solid black;
  margin: 10px;
  padding: 5px;
  padding-top: 0;
  justify-content: center;
}

@media print {
  header {
    display: none;
  }

  .row {
    margin-top: 5rem;
  }
}
</style>
